import { SVGProps } from 'react';

export const Surrender = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 43 42"
        {...props}
    >
        <path
            fill="#fff"
            d="M15.573 22.2s1.657 1.91 6.23 1.021c4.556-.887 4.438-3.373 7.412-4.364 2.974-.992 4.335.222 4.335.222l-1.997-12.68s-4.128-.844-6.94.37c-2.81 1.213-1.642 5.134-5.296 5.652-3.655.517-5.52-.888-5.52-.888l1.79 10.653-.014.015ZM13.77 35.695c.902-.118 1.524-.887 1.39-1.701l-3.758-22.15c-.133-.813-.976-1.376-1.879-1.242-.902.118-1.524.887-1.39 1.701l3.758 22.15c.133.813.976 1.376 1.879 1.242Z"
        />
    </svg>
);
